var map = {
	"./INTERNSHIP-LOGO.png": 1847,
	"./address_image.svg": 599,
	"./ajay1.png": 624,
	"./ajay2.png": 1869,
	"./ajay_photo23.png": 8057,
	"./animated_logo.svg": 7733,
	"./blogs_image.svg": 2885,
	"./cloud_infrastructure.svg": 7957,
	"./coding-ninjas-logo-white.png": 6508,
	"./contactMail.png": 9581,
	"./coursera_logo.png": 1877,
	"./data_science.svg": 8938,
	"./developerActivity.svg": 6715,
	"./education.svg": 855,
	"./experience.svg": 9917,
	"./feelingProud.svg": 658,
	"./fullstack.svg": 2043,
	"./github_logo.png": 9551,
	"./googleAssistant.svg": 3564,
	"./google_logo.png": 5927,
	"./hackerrank-icon.png": 6002,
	"./jsFramework.svg": 8446,
	"./logo-davv.png": 520,
	"./logo-sage.png": 8267,
	"./logo-sage1.jpg": 9576,
	"./manOnTable.svg": 3034,
	"./programmer.svg": 9220,
	"./projects_image.svg": 4716,
	"./talksCardBack.svg": 5331,
	"./talksCardBackAlt.svg": 7945,
	"./ui_ux_design.svg": 2337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;